module.exports = __webpack_public_path__ + "img/mang3.e58276af.jpg";